import React from 'react';
import { ConfidentialityLevel } from '../../../GlobalConst/globalEnums';
import InfoTooltip from '../../formFields/InfoTooltip';

const financialDataTooltip =
    <div>
        <b>Financial reporting data</b> is used directly or indirectly to track, analyze, and report ABB’s business income. This helps ABB and investors make informed decisions about how to manage the business. These reports examine resource usage and cash flow to assess the financial health of the business.
        The basic financial statements include:
        <ul>
            <li>Balance sheet (or statement of financial position)</li>
            <li>Income statement</li>
            <li>Cash flow statement</li>
            <li>Statement of changes in owners' or stockholders' equity</li>
        </ul>
        Is the solution you are developing going to support directly or indirectly the operational effectiveness of a business process or will it provide evidence to support one of these business processes: Record to Report, Procure to Pay, Order to Cash,  Hire to Retire, Tax, Treasury, IT General Controls
    </div>

export const LightWeightAssessmentQA = {
    scope: {
        question: "Is this solution for personal productivity/for yourself or Business purposes with wider team?",
        answers: {
            PersonalProductivity: "Personal Productivity",
            BusinessPurposes: "Business purposes"
        }
    },
    personalData: {
        question: <span>Will your Power Platform application process Personal Data? (Refer here <a href="https://go.insideplus.abb.com/information-systems/gf-is/is-teams/information-security/security-policies-standards">Security Policies & Standards</a>)</span>,
        answers: {
            NoPersonalData: "No Personal Data will not be processed.",
            LimitedPersonalData: "Yes, Personal Data will be collected and/or processed, but it is limited only to common types including First and Last Name, business email address, business telephone number, business location, job/role/position.",
            PersonalData: "Yes, Personal Data will be collected and/or processed which are in addition to the ones listed above."
        },
    },
    financialData: {
        question: <span>Would your application or workflow be working with or processing/storing ABB's Financial Data? <InfoTooltip content={financialDataTooltip} /></span>,
        answers: {
            true: "Yes",
            false: "No"
        },
    },
    militaryData: {
        question: <span>Would your application or workflow be working with or processing/storing Military or Dual Use documentation , or some very specific document types, including bills or materials (BOM), technical drawings or CAD files (find a more detailed set of examples here <a href="https://go.insideplus.abb.com/ch/group-functions/global-trade-portal-2.0">Global Trade Portal 2.0</a>)?</span>,
        answers: {
            true: "Yes",
            false: "No"
        },
    },
    otherApplicationsConnected: {
        question: "Apart from M365, will your Power Platform solution connect to any other Applications?",
        answers: {
            true: "Yes",
            false: "No"
        },
    },
    classification: {
        question: <span>Will your Power Platform solution be creating, processing or storing data or information that would be classified as Confidential or Strictly Confidential under the ABB Information Classification Standard (<a href="https://search.abb.com/library/Download.aspx?DocumentID=9AAD126846&LanguageCode=en&DocumentPartId=&Action=Launch">Link</a>)?</span>,
        answers: ConfidentialityLevel,
    },
    impact: {
        question: "What would be the impact on ABB in case of unauthorized access, data leakage/loss or unavailability of your Power Platform solution?",
        answers: {
            Low: "Low (Limited to no impact to a few people or myself)",
            Medium: "Medium (Some business impact to multiple people)",
            High: "High (Significant business impact to multiple people)"
        },
    },
    vendor: {
        question: <span>Is there a vendor involved, out of <a href="https://go.insideplus.abb.com/information-systems/gf-is/is-teams/global-is-vendor-management">Global IS Vendor Management</a>?</span>,
        answers: {
            true: "Yes",
            false: "No"
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/LightWeightAssessmentQA.js